import { render } from "./textEditor.vue?vue&type=template&id=629316c1&scoped=true"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"

import "./textEditor.vue?vue&type=style&index=0&id=629316c1&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629316c1"]])

export default __exports__